/**
 * Toasts that stay on screen until the user closes them.
 *
 * Comms 9/23 review: alerts on Campaign Builder and Keyword Research
 * disappeared before anyone could read them (the app-wide default is 4s).
 * Only the calls that use this helper change. The global Toaster in App.tsx
 * is untouched and already renders a close button on every toast.
 */
import { toast, type ExternalToast } from 'sonner';

type Kind = 'success' | 'error' | 'warning' | 'info';
type Message = Parameters<typeof toast.success>[0];

const STAY_UNTIL_CLOSED: ExternalToast = { duration: Infinity };

// Looked up at call time, not import time, so a test that mocks only some
// of sonner's methods still loads this module.
function sticky(kind: Kind) {
  return (message: Message, options?: ExternalToast) =>
    toast[kind](message, { ...STAY_UNTIL_CLOSED, ...options });
}

export const stickyToast = {
  success: sticky('success'),
  error: sticky('error'),
  warning: sticky('warning'),
  info: sticky('info'),
};
